import { CoinflipTemplate } from '@/components/templates/Coinflip'
import { useAppModal, AppModals } from '@/context/ModalProvider'
import { useMaintenance } from '@/hooks/useMaintenance'
import { useEffect } from 'react'

const CoinflipPage = () => {
  const { isMaintenance } = useMaintenance()
  const modal = useAppModal()

  useEffect(() => {
    if (isMaintenance) {
      modal.openModalNew(AppModals.MaintenanceModal)
    }
  }, [])

  return <CoinflipTemplate />
}

export default CoinflipPage
